import React from 'react';
import ReactDOM from 'react-dom/client';
import './fonts/Nunito-Regular.ttf'
import './index.css';
import App from './App';
import ToastContainer from './NewUI/NewComponents/ToastContainer';

import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<>
  {/* <React.StrictMode> */}
  <HelmetProvider>
    <App />
  </HelmetProvider>
  <ToastContainer />

  {/* </React.StrictMode> */}
</>);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
